<template>
    <div v-if="isOpen" class="modal-overlay" @click.self="$emit('close')">
      <div class="modal-content">
        <button class="close-btn" @click="$emit('close')">&times;</button>
        <component :is="component" v-bind="props" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BaseModal",
    props: {
      isOpen: Boolean, // Controls visibility
      component: Object, // Component to render inside the modal
      props: Object, // Props to pass to the dynamic component
    },
  };
  </script>
  
  <style scoped>
.modal-overlay {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
 width: 95%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px; /* Add padding to avoid issues on small screens */
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh; /* Prevent modal from overflowing */
  overflow-y: auto; /* Enable scrolling if content is too long */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Improve close button positioning */
.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

/* Mobile-friendly adjustments */
@media screen and (max-width: 480px) {
  .modal-content {
    width: 95%; /* Make it take up more space on small screens */
    padding: 15px; /* Reduce padding for smaller screens */
  }
}
</style>